import proj4 from 'proj4';
import { EPSG3067 } from '../config';

/**
 * Returns list of events transformed to map features.
 * @param {Array<object>} events
 * @return {Array<object>} Array of map features.
 */
export default function eventsToMap(events) {
  return events.map((event) => {
    const coordinates = proj4(EPSG3067, [parseFloat(event.LAT), parseFloat(event.LON)]);

    return {
      id: event.EVENT_ID,
      x: coordinates[0],
      y: coordinates[1],
      color: 'ff0000',
      msg: '',
      shape: 2,
      size: 3
    };
  });
}



// WEBPACK FOOTER //
// ./src/services/eventsToMap.js